// extracted by mini-css-extract-plugin
export default {"mask":"index_mask_6glEm","maskContent":"index_maskContent_Uesr-"};